import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from 'state'
import { NftItem, OrderByAs, OrderBy } from './types'
import fetchNft from './actions/fetchNft'
import fetchNext from './actions/fetchNext'
import fetchFavoritedNft from './actions/fetchFavoritedNft'

export interface NftState {
  status: 'idle' | 'loading' | 'loading-next' | 'failed'
  isFirstTimeLoad: boolean
  hasMore: boolean
  orderBy: OrderBy
  orderByAs: OrderByAs
  search: string
  limit: number
  offset: number
  items: NftItem[]
}

const initialState: NftState = {
  status: 'idle',
  isFirstTimeLoad: true,
  hasMore: true,
  orderBy: 'stats.sevenDayVolume',
  orderByAs: 'desc',
  search: '',
  limit: 15,
  offset: 0,
  items: []
}

export const nftSlice = createSlice({
  name: 'nft',
  initialState,
  reducers: {
    changeOrderBy(state, action: PayloadAction<{ orderBy: OrderBy; orderByAs: OrderByAs }>) {
      state.orderBy = action.payload.orderBy
      state.orderByAs = action.payload.orderByAs
    },
    changeSearch(state, action: PayloadAction<string>) {
      state.search = action.payload
      state.offset = 0
    },
    increaseOffset(state, action: PayloadAction<number>) {
      state.offset += action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchNft.rejected, state => {
        state.status = 'failed'
      })
      .addCase(fetchNft.pending, state => {
        state.status = 'loading'
      })
      .addCase(fetchNft.fulfilled, (state, action) => {
        state.status = 'idle'
        state.items = action.payload.items
        state.hasMore = action.payload.hasMore
        state.isFirstTimeLoad = false
        state.offset = 0
      })

      .addCase(fetchNext.rejected, state => {
        state.status = 'failed'
      })
      .addCase(fetchNext.pending, state => {
        state.status = 'loading-next'
      })
      .addCase(fetchNext.fulfilled, (state, action) => {
        state.status = 'idle'
        state.items = action.payload.items
        state.hasMore = action.payload.hasMore
      })

      .addCase(fetchFavoritedNft.rejected, state => {
        state.status = 'failed'
      })
      .addCase(fetchFavoritedNft.pending, state => {
        state.status = 'loading'
      })
      .addCase(fetchFavoritedNft.fulfilled, (state, action) => {
        state.status = 'idle'
        state.offset = initialState.offset
        state.items = action.payload.items
        state.hasMore = action.payload.hasMore
        state.isFirstTimeLoad = false
      })
  }
})

export const selectNft = (state: AppState) => state.nft
export const { changeOrderBy, changeSearch, increaseOffset } = nftSlice.actions

export default nftSlice.reducer
